import React from "react";
import PhoneInput from "../phone-input";
import clsx from "clsx";
import Link from "components/link";
import ErrorMessage from "components/error-message";
import useKlaviyoSubscription from "hooks/useKlaviyoSubscription";
import { useSettings } from "hooks/useStore";

const SuccessMessage = ({ isSecondStep }) => (
	isSecondStep ? (
		<div className="h-128 w-full flex items-center justify-center">
			<h2 className="p-20 text-h2 sm:text-h3 ">Thank you for subscribing!</h2>
		</div>
	) : (
		<h3 className="py-20 text-center">Thank you for subscribing!</h3>
	)
);

const PhoneSignupForm = ({ data, emailSuccess, phoneNumber, error, onChange, handlePhoneSubmit, isSecondStep }) => (
	<>
		<div className="flex flex-col gap-2 mt-5">
			<h2>{emailSuccess ? "You're in! One more step!" : data.title}</h2>
			<p className="py-1.5">{data.description}</p>
		</div>

		{!isSecondStep && (
			<><h4 className="font-semibold my-3">Sign up for early access</h4>
				<p className="text-secondary my-3">Get exclusive access right from your phone.</p></>
		)}
		<form onSubmit={handlePhoneSubmit} className="gap-4 w-full flex flex-col lg:flex-row">
			<PhoneInput value={phoneNumber} onChange={(e) => onChange(e)} />
			<button type="submit"
				className={clsx("btn-secondary hover:text-black hover:bg-beige w-full md:w-fit",
					!isSecondStep ? "bg-black text-white rounded" : "tracking-normal"
				)}>
				SUBSCRIBE
			</button>
		</form>

		{error && <ErrorMessage message={error} />}

		<p className={clsx(!error && "mt-3", "text-xs")}>
			By submitting this form and signing up for texts, you consent to receive
			marketing text messages (e.g., promos, cart reminders) from
			MOD LIGHTING at the number provided. Msg & data rates may apply.
			Unsubscribe at any time by replying STOP.
			<Link className="text-blue-600" to="/privacy-policy"> Privacy Policy </Link>
			<span className="px-0.5">&</span>
			<a target="_BLANK" rel="noreferrer" href="https://mod-lighting.myklpages.com/p/mobile-terms-of-service"
				className="text-blue-600"> Terms </a>
		</p>
	</>
);
const SmsSignUpForm = ({ data, emailSuccess, isSecondStep = false }) => {
	const { klaviyoEmail, updateKlaviyoEmail } = useSettings(["klaviyoEmail", "updateKlaviyoEmail"]);
	const { success, phoneNumber, error, handleSubscribe, onChange } = useKlaviyoSubscription(data.id, true);
	const handlePhoneSubmit = async (e) => {
		e.preventDefault();
		const profileAttributes = {
			...(klaviyoEmail && { email: klaviyoEmail }),
			phone_number: phoneNumber,
			...(!isSecondStep && { properties: { sms_source: "Early Access Page" } })
		};

		const result = await handleSubscribe(e, profileAttributes);
		if (result?.success) {
			setTimeout(() => {
				updateKlaviyoEmail(null);
			}, 5000);
		}
	};

	return (
		<>
			{success ? (
				<SuccessMessage isSecondStep={isSecondStep} />
			) : (
				<PhoneSignupForm data={data} emailSuccess={emailSuccess} phoneNumber={phoneNumber} error={error}
					onChange={onChange} handlePhoneSubmit={handlePhoneSubmit} isSecondStep={isSecondStep} />
			)}
		</>
	);
};

export default SmsSignUpForm;
